import type { TranslocoService } from '@jsverse/transloco';

const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 1440;

/**
 * Human label for a delivery interval ("Cada 2 días", "Cada 1 hora", "Cada 90 minutos").
 * Uses the largest unit that divides the interval exactly, so 90 min is never shown as "2 h".
 * Plural via separate one/other keys under subscriptions.interval.*.
 */
export function subscriptionIntervalLabel(minutes: number, transloco: TranslocoService): string {
	const mins = Math.max(0, Math.round(Number(minutes) || 0));
	let unit: 'day' | 'hour' | 'minute' = 'minute';
	let count = mins;
	if (mins > 0 && mins % MINUTES_PER_DAY === 0) {
		unit = 'day';
		count = mins / MINUTES_PER_DAY;
	} else if (mins > 0 && mins % MINUTES_PER_HOUR === 0) {
		unit = 'hour';
		count = mins / MINUTES_PER_HOUR;
	}
	const key = count === 1 ? unit : `${unit}s`;
	return transloco.translate(`subscriptions.interval.${key}`, { count });
}
